import { useUserStore } from "~/stores/usuario_store";

export default defineNuxtRouteMiddleware((to, from) => {
  const userStore = useUserStore();

  if (process.server) return;

  useAPI.get(`/geral/gupv1/?or=admin`, userStore.user.token).then(async ({ data }) => {
    if (data.error != "d") {
      await navigateTo("/");
    }
  });
});
